import { CardActions } from '@mui/material';
import { forwardRef, ReactElement, ReactNode, Ref } from 'react';
import { CardProps } from '../Card';
import { Divider } from '../Divider';
import { Typography } from '../Typography';
import {
  RowStack,
  StyledBorder,
  StyledCard,
  StyledCardContent,
  StyledCardHeader,
  StyledStack,
  StyledTypography,
} from './PageCardContainer.styles';

export interface PageCardContainerProps extends CardProps {
  readonly title: string | ReactElement;
  readonly subheader?: string;
  readonly borderColor?: string;
  readonly Toolbar?: ReactElement;
  readonly cardAction?: ReactNode;
  readonly children?: ReactNode;
  readonly noPadding?: boolean;
  readonly width?: string;
  readonly divider?: boolean;
}

const PageCardContainerComponent = forwardRef(
  (
    {
      title,
      subheader,
      cardAction,
      Toolbar,
      children,
      borderColor,
      noPadding,
      divider = true,
      ...rest
    }: PageCardContainerProps,
    ref: Ref<HTMLDivElement>,
  ) => (
    <StyledCard {...rest} ref={ref}>
      <StyledCardHeader
        action={Toolbar}
        title={
          typeof title === 'string' ? (
            <RowStack>
              {borderColor ? <StyledBorder borderColor={borderColor} /> : null}
              <StyledStack>
                <Typography variant="h5">{title}</Typography>
                {subheader ? (
                  <StyledTypography variant="subtitle">
                    {subheader}
                  </StyledTypography>
                ) : null}
              </StyledStack>
            </RowStack>
          ) : (
            title
          )
        }
      />
      {divider ? (
        <Divider fullWidth light noMargin orientation="horizontal" />
      ) : null}
      <StyledCardContent noPadding={noPadding}>{children}</StyledCardContent>
      {cardAction ? (
        <StyledCard>
          {divider ? (
            <Divider fullWidth light noMargin orientation="horizontal" />
          ) : null}
          <CardActions disableSpacing>{cardAction}</CardActions>
        </StyledCard>
      ) : null}
    </StyledCard>
  ),
);
export const PageCardContainer = PageCardContainerComponent;
